import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { currencyRatesSelector } from '../../../redux/reducers/common/common_reducers/currencyRates';
import { currencySelector } from '../../../redux/reducers/common/common_reducers/currency';
import { getCurrencySymbol } from '../../common/SelectCurrency';
import { useTranslation } from 'react-i18next';

export const CURRENCIES = {
    USD: 'USD',
    EUR: 'EUR',
    GEL: 'GEL',
};

export const Currency = ({ item, top, isRent, isPlacement }) => {
    const { t } = useTranslation();
    const rates = useSelector(currencyRatesSelector);
    const currency = useSelector(currencySelector);

    const isAdvert = typeof item === 'object' && item !== null;
    const basePrice = isAdvert ? item.price : item;
    const negotiable = isAdvert && !(Number(basePrice) > 0);

    const price = useMemo(() => {
        if (!rates || !rates.usd || !rates.eur) return 0;
        const priceInUsd = +basePrice;
        if (!priceInUsd) return 0;
        if (currency === CURRENCIES.GEL) return Math.round(priceInUsd * rates.usd);
        if (currency === CURRENCIES.EUR) return Math.round(priceInUsd * rates.eur);
        return priceInUsd;
    }, [currency, rates, basePrice]);

    const className = top
        ? 'currency-container-top'
        : negotiable
          ? 'currency-container currency-container--text'
          : 'currency-container';

    return (
        <div className={className}>
            {negotiable && t('priceNegotiable')}
            {price > 0 && (
                <>
                    {price}
                    {getCurrencySymbol(currency)}
                    {isPlacement
                        ? t('priceMonth')
                        : isRent
                          ? t('priceDay')
                          : null}
                </>
            )}
        </div>
    );
};
